import React from "react";
import ChartistGraph from "react-chartist";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  Image,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import { Label } from "reactstrap";
import { getAllTotalAreaManager } from "stores";
import { getAllTotalPengajuan } from "stores";
import ReactDatetime from "react-datetime";
import { getTotalPencairan } from "stores/Pengajuan/function";
import { getGrafikPencairanCabang } from "stores";
import moment from "moment";
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLabel,
  VictoryLegend,
  VictoryTheme,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from "victory";
import { getTotalTargetUser } from "stores/Pengajuan/function";
import { getGrafikPencairanUser } from "stores";
import { getAllTotalSupervisor } from "stores";
import { getAllTotalMarketing } from "stores";
import { getAllTotalCabang } from "stores";
import { getExportPengajuan } from "stores";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function DashboardUtama() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const cardTotalAreaManager = useSelector(
    (state) => state.dashboardUtamaReducer,
  );
  // const cardTotalPencairan = useSelector((state) => state.pengajuanReducer);
  const cardTotalPengajuan = useSelector(
    (state) => state.dashboardUtamaReducer,
  );
  // console.log(cardTotalPengajuan, "Dari Store");
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const totalTarget = hasilPresentase > 100;
  const [listAllTotalPengajuan, setListAllTotalPengajuan] = React.useState([]);
  const [totalNominalPencairan, setTotalNominalPencairan] = React.useState(0);
  const [totalNominalPencairanKonsumtif, setTotalNominalPencairanKonsumtif] =
    React.useState(0);
  const [totalNominalPencairanProduktif, setTotalNominalPencairanProduktif] =
    React.useState(0);
  const [hasilPresentase, setHasilPresentase] = React.useState(0);
  const [totalNominalTarget, setTotalNominalTarget] = React.useState(0);
  const [dataGrafikCabang, setDataGrafikCabang] = React.useState([]);
  const [dataGrafikUser, setDataGrafikUser] = React.useState([]);
  const [totalSpv, setTotalSpv] = React.useState([]);
  const [totalCbg, setTotalCbg] = React.useState([]);
  const [kategoriKredit, setKategoriKredit] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [loadingPresentase, setLoadingPresentase] = React.useState(false);
  const [totalAM, setTotalAM] = React.useState([]);
  const [totalMarketing, setTotalMarketing] = React.useState([]);
  const [dataAllGrafikCabang, setDataAllGrafikCabang] = React.useState([]);
  const [dariTgl, setDariTgl] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [smpTgl, setSmpTgl] = React.useState(new Date());
  const pencairanData = dataGrafikCabang.map((item) => item.totalPencairan);
  const pencairanDataKonsumtif = dataGrafikCabang.map(
    (item) => item.totalNominalKonsumtif,
  );
  const pencairanDataProduktif = dataGrafikCabang.map(
    (item) => item.totalNominalProduktif,
  );

  const targetData = dataGrafikCabang.map((item) => item.totalTarget);
  const [tahun, setTahun] = React.useState(new Date().getFullYear());
  let yearNow = new Date().getFullYear();
  const [listYear, setListYear] = React.useState([]);
  const bulanData = dataGrafikUser.map((item) => item.bulan);
  const pencairanDataUser = dataGrafikUser.map(
    (item) => item.totalNominalPencairan,
  );
  const targetDataUser = dataGrafikUser.map((item) => item.totalNominalTarget);
  const pencairanDataUserKonsumtif = dataGrafikUser.map(
    (item) => item.totalNominalKonsumtif,
  );
  const pencairanDataUserProduktif = dataGrafikUser.map(
    (item) => item.totalNominalProduktif,
  );
  const abjadCabang = dataGrafikCabang.map((_, index) =>
    String.fromCharCode(65 + index),
  );
  //Modal
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalExport, setModalExport] = React.useState(false);
  const [hoverBatal, setHoverBatal] = React.useState(false);
  const [loadingChart, setLoadingChart] = React.useState(true);
  const [filterText, setFilterText] = React.useState("");

  const filteredItems = dataAllGrafikCabang.filter(
    (item) =>
      item.nama && item.nama.toLowerCase().includes(filterText.toLowerCase()),
  );

  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const closeModal = () => {
    setCurrentPage(1);
    setModalDetail(false);
  };

  const chartData = {
    labels: abjadCabang,
    series: [
      pencairanData,
      targetData,
      pencairanDataKonsumtif,
      pencairanDataProduktif,
    ],
  };

  const chartDataUser = {
    labels: bulanData,
    series: [
      targetDataUser,
      pencairanDataUser,
      pencairanDataUserKonsumtif,
      pencairanDataUserProduktif,
    ],
  };

  React.useEffect(() => {
    // setIsVisible(true);s
    getListYear();
  }, []);

  // const submitExport = async (e) => {
  //   e.preventDefault();
  //   if (tglAwal === "" || tglAkhir === "" || status === "") {
  //     Swal.fire({
  //       title: "Semua Field Wajib Diisi",
  //       icon: "warning",
  //     });
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Konfirmasi Export Pengajuan",
  //     text: `Apakah Anda ingin mengexport dari ${moment(tglAwal).format(
  //       "DD MMMM YYYY"
  //     )} sampai ${moment(tglAkhir).format("DD MMMM YYYY")} ?`,
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Ya, Export",
  //     cancelButtonText: "Batal",
  //     allowOutsideClick: () => !Swal.isLoading(),
  //     showLoaderOnConfirm: true,
  //     preConfirm: async () => {
  //       try {
  //         // Meminta server untuk ekspor data
  //         const response = await getExportPengajuan({
  //           tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
  //           tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
  //           status: status.value,
  //         });

  //         // Mengaktifkan unduhan setelah menerima respons dari server
  //         const url = window.URL.createObjectURL(new Blob([response.data]));
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute(
  //           "download",
  //           `Export Pengajuan ${status.value}.xlsx`
  //         );
  //         document.body.appendChild(link);
  //         link.click();
  //         link.parentNode.removeChild(link);

  //         // Tampilkan swal.fire setelah unduhan selesai
  //         Swal.fire({
  //           icon: "success",
  //           title: "Data berhasil diexport",
  //         });
  //       } catch (error) {
  //         Swal.fire({
  //           title: "Terjadi kesalahan",
  //           text: error.message,
  //           icon: "error",
  //         });
  //       }
  //     },
  //   });
  // };

  // const submitExport = (e) => {
  //   e.preventDefault();
  //   if (tglAwal === "" || tglAkhir === "" || status === "") {
  //     Swal.fire({
  //       title: "Semua Field Wajib Diisi",
  //       icon: "warning",
  //     });
  //     return;
  //   }
  //   getExportPengajuan({
  //     tglAwal: tglAwal,
  //     tglAkhir: tglAkhir,
  //     status: status.value,
  //   });
  // };

  // const submitExport = (e) => {
  //   e.preventDefault();
  //   // console.log(tglAwal, tglAkhir, status.value, "ASLKASDASDSAD");
  //   // if (status === "") {
  //   //   Swal.fire({
  //   //     title: "Status Harus Diisi",
  //   //     icon: "warning",
  //   //   });
  //   //   return;
  //   // }
  //   getExportPengajuan({
  //     tglAwal: tglAwal,
  //     tglAkhir: tglAkhir,
  //     statusPengajuan: status.value,
  //   });
  // };

  const submitExport = async (e) => {
    e.preventDefault();
    if (
      tglAwal === "" ||
      tglAkhir === "" ||
      status === "" ||
      kategoriKredit === ""
    ) {
      Swal.fire({
        title: "Semua Field Wajib Diisi",
        icon: "warning",
      });
      return;
    }

    Swal.fire({
      title: "Konfirmasi Export Pengajuan",
      text: `Apakah Anda ingin mengexport dari ${moment(tglAwal).format(
        "DD MMMM YYYY",
      )} sampai ${moment(tglAkhir).format("DD MMMM YYYY")} ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya, Export",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          // Meminta server untuk ekspor data
          const response = await getExportPengajuan({
            tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
            tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
            kategoriKredit: kategoriKredit.value,
            status: status.value,
          });

          // Mengaktifkan unduhan setelah menerima respons dari server
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Export Pengajuan ${kategoriKredit.label} ${status.value}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);

          // Tampilkan swal.fire setelah unduhan selesai
          Swal.fire({
            icon: "success",
            title: "Data berhasil diexport",
          });
        } catch (error) {
          Swal.fire({
            title: "Terjadi kesalahan",
            text: error.message,
            icon: "error",
          });
        }
      },
    });
  };

  const handleExportPengajuan = () => {
    setStatus("");
    // setTglAwal("");
    // setTglAkhir("");
  };

  React.useEffect(() => {
    let tmp =
      cardTotalPengajuan.totalPengajuan &&
      cardTotalPengajuan.totalPengajuan.map((val) => {
        return {
          ...val,
        };
      });
    setListAllTotalPengajuan(tmp || []);
  }, [cardTotalPengajuan.totalPengajuan]);

  React.useEffect(() => {
    getAllTotalPengajuan(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    });
  }, [dariTgl, smpTgl]);

  const getListYear = () => {
    let tmp = [];
    for (let i = 5; i >= 0; i--) {
      let years = yearNow--;
      tmp.push({
        value: years,
        label: years,
      });
    }
    setListYear(tmp);
  };

  React.useEffect(() => {
    setLoadingPresentase(true);
    getTotalPencairan(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      setLoadingPresentase(false);
      const totalPencairan = response.data.totalNominal;
      setTotalNominalPencairan(totalPencairan);
      const totalPencairanKonsumtif = response.data.totalNominalKonsumtif;
      setTotalNominalPencairanKonsumtif(totalPencairanKonsumtif);
      const totalPencairanProduktif = response.data.totalNominalProduktif;
      setTotalNominalPencairanProduktif(totalPencairanProduktif);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    getTotalTargetUser(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalTarget = response.data.totalTarget;
      setTotalNominalTarget(totalTarget);
    });
  }, [dariTgl, smpTgl]);

  // EFFECT 1: GRAFIK CABANG
  React.useEffect(() => {
    setLoadingChart(true);
    getGrafikPencairanCabang(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    })
      .then((response) => {
        if (response && response.data) {
          const grafikCabang = response.data;
          let tmp = [];
          grafikCabang.map((val, index) => {
            if (index < 12) {
              tmp.push(val);
            }
          });

          // Urutan penting: Set data dulu, baru matikan loading
          setDataGrafikCabang(tmp);
          setDataAllGrafikCabang(grafikCabang);

          // Tambahkan sedikit delay (optional 100ms) agar render mesin Victory siap
          setTimeout(() => {
            setLoadingChart(false);
          }, 200);
        }
      })
      .catch(() => setLoadingChart(false));
  }, [dariTgl, smpTgl]);

  // EFFECT 2: GRAFIK USER
  React.useEffect(() => {
    setLoadingChart(true); // Mulai loading
    getGrafikPencairanUser(dispatch, {
      tahun: tahun,
    })
      .then((response) => {
        const grafikUser = response.data;
        setDataGrafikUser(grafikUser);

        // Matikan loading di sini juga
        setLoadingChart(false);
      })
      .catch(() => setLoadingChart(false));
  }, [tahun]);

  React.useEffect(() => {
    if (totalNominalTarget !== 0 && totalNominalPencairan !== 0) {
      const presentase = Math.round(
        (totalNominalPencairan / totalNominalTarget) * 100,
      );
      setHasilPresentase(presentase);
    } else {
      setHasilPresentase(0);
    }
  }, [totalNominalPencairan, totalNominalTarget]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9",
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        letterSpacing: "0.5px",
        justifyContent: "flex-start", // Paksa header rata kiri
      },
    },
    rows: {
      style: {
        minHeight: "70px",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Paksa isi sel rata kiri
      },
    },
  };

  const colCabangPencairan = [
    {
      name: "NO",
      width: "70px",
      center: false,
      cell: (row, index) => (
        <span className="fw-800 text-muted ml-2" style={{ fontSize: "14px" }}>
          {(currentPage - 1) * itemsPerPage + index + 1}
        </span>
      ),
    },
    {
      name: "NAMA CABANG",
      minWidth: "250px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1">
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-lg"
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#f0fdf4",
              color: "#16a34a",
              border: "1px solid #dcfce7",
            }}
          >
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <span className="fw-900 text-dark" style={{ fontSize: "15px" }}>
            {row.nama}
          </span>
        </div>
      ),
    },
    {
      name: "TOTAL PENCAIRAN",
      minWidth: "220px",
      center: false,
      cell: (row) => {
        const formattedValue = row.totalPencairan.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        });
        return (
          <div className="ml-1">
            <div
              className="small fw-800 text-muted uppercase mb-1"
              style={{ fontSize: "10px", letterSpacing: "0.5px" }}
            >
              REALISASI
            </div>
            <span
              className="fw-900 text-success"
              style={{ fontSize: "16px", fontWeight: "900" }}
            >
              {formattedValue}
            </span>
          </div>
        );
      },
    },
    {
      name: "TOTAL TARGET",
      minWidth: "220px",
      center: false,
      cell: (row) => {
        const formattedValue = row.totalTarget.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        });
        return (
          <div className="ml-1">
            <div
              className="small fw-800 text-muted uppercase mb-1"
              style={{ fontSize: "10px", letterSpacing: "0.5px" }}
            >
              TARGET
            </div>
            <span className="fw-900 text-primary" style={{ fontSize: "16px" }}>
              {formattedValue}
            </span>
          </div>
        );
      },
    },
  ];

  React.useEffect(() => {
    getAllTotalSupervisor(dispatch).then((response) => {
      const dataSupervisor = response.data;
      setTotalSpv(dataSupervisor);
    });
  }, []);

  React.useEffect(() => {
    getAllTotalAreaManager(dispatch).then((response) => {
      const dataAreaManager = response.data;
      setTotalAM(dataAreaManager);
    });
  }, []);

  React.useEffect(() => {
    getAllTotalMarketing(dispatch).then((response) => {
      const dataMarketing = response.data;
      setTotalMarketing(dataMarketing);
    });
  }, []);

  React.useEffect(() => {
    getAllTotalCabang(dispatch).then((response) => {
      const dataCabang = response.data;
      setTotalCbg(dataCabang);
    });
  }, []);

  React.useEffect(() => {
    if (auth.role === "client") {
      const interval = setInterval(() => {
        window.location.reload();
        refresh();
      }, 300000);

      return () => clearInterval(interval);
    }
  }, [auth.role]);

  return (
    // <SkeletonTheme baseColor="#c713eb" highlightColor="#de84f0">
    <>
      <Modal
        size="lg"
        show={modalExport}
        onHide={() => setModalExport(false)}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />

        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#10b981",
                borderRadius: "20px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(16, 185, 129, 0.2)",
                marginBottom: "15px",
              }}
            >
              <i className="fas fa-file-excel fa-2x text-white"></i>
            </div>
            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Export Data Pengajuan
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Silahkan pilih filter data yang ingin Anda unduh
            </p>
          </div>

          <Form className="form">
            <Card
              style={{
                border: "none",
                borderRadius: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
              }}
            >
              <Card.Body className="p-4">
                <Row>
                  {/* TANGGAL AWAL */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="far fa-calendar-alt mr-2 text-primary"></i>{" "}
                        Tanggal Awal
                      </label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control border-0 bg-light p-3",
                          placeholder: "Mulai Dari",
                          readOnly: true,
                          style: {
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "15px",
                          },
                        }}
                        onChange={(e) =>
                          setTglAwal(e.toDate().setHours(0, 0, 0, 0))
                        }
                        value={tglAwal}
                        timeFormat={false}
                      />
                    </Form.Group>
                  </Col>

                  {/* TANGGAL AKHIR */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="far fa-calendar-check mr-2 text-primary"></i>{" "}
                        Tanggal Akhir
                      </label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control border-0 bg-light p-3",
                          placeholder: "Sampai Dengan",
                          readOnly: true,
                          style: {
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "15px",
                          },
                        }}
                        onChange={(e) =>
                          setTglAkhir(e.toDate().setHours(23, 59, 59, 999))
                        }
                        value={tglAkhir}
                        timeFormat={false}
                      />
                    </Form.Group>
                  </Col>

                  {/* KATEGORI KREDIT */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-layer-group mr-2 text-primary"></i>{" "}
                        Kategori Kredit
                      </label>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        onChange={(value) => setKategoriKredit(value)}
                        options={[
                          { value: "", label: "Semua Kategori" },
                          { value: "konvensional", label: "Konvensional" },
                          { value: "syariah", label: "Syariah" },
                        ]}
                        placeholder="Pilih Kategori"
                      />
                    </Form.Group>
                  </Col>

                  {/* STATUS */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-info-circle mr-2 text-primary"></i>{" "}
                        Status Pengajuan
                      </label>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        onChange={(value) => setStatus(value)}
                        options={[
                          { value: "Semua", label: "Semua Pengajuan" },
                          { value: "Disetujui", label: "Disetujui" },
                          { value: "Diproses", label: "Diproses" },
                          {
                            value: "Menunggu Konfirmasi",
                            label: "Menunggu Konfirmasi",
                          },
                          { value: "Revisi", label: "Revisi" },
                          { value: "Ditolak", label: "Ditolak" },
                        ]}
                        placeholder="Pilih Status"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="mt-4">
                  <Button
                    className="btn-block p-3"
                    style={{
                      border: "none",
                      backgroundColor: "#10b981",
                      boxShadow: "0 10px 20px rgba(16, 185, 129, 0.3)",
                      borderRadius: "15px",
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                    onClick={submitExport}
                  >
                    <i className="fas fa-file-download mr-2"></i> UNDUH LAPORAN
                    EXCEL
                  </Button>
                  <Button
                    variant="link"
                    className="btn-block mt-2 font-weight-bold"
                    style={{
                      textDecoration: "none",
                      color: hoverBatal ? "#dc3545" : "#6c757d",
                      transition: "all 0.2s ease-in-out",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setHoverBatal(true)}
                    onMouseLeave={() => setHoverBatal(false)}
                    onClick={() => setModalExport(false)}
                  >
                    BATALKAN
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="xl"
        show={modalDetail}
        onHide={closeModal}
        centered
        style={{ borderRadius: "24px" }}
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: "1px solid #f1f5f9", padding: "20px 30px" }}
        >
          <Modal.Title className="d-flex align-items-center">
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#EEF2FF",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "15px",
              }}
            >
              <i className="fas fa-search text-primary"></i>
            </div>
            <div>
              <h5 className="m-0 font-weight-bold" style={{ color: "#1e293b" }}>
                Rincian Data Cabang
              </h5>
              <small className="text-muted">
                Cari dan lihat detail pencairan tiap cabang
              </small>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">
          <Card style={{ border: "none", margin: "0" }}>
            <Card.Body style={{ padding: "30px" }}>
              {/* --- INPUT PENCARIAN (AKTIF) --- */}
              <div className="mb-4 d-flex justify-content-between align-items-center">
                <div
                  className="input-group"
                  style={{
                    maxWidth: "350px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    borderRadius: "10px",
                  }}
                >
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text bg-white border-right-0"
                      style={{ borderRadius: "10px 0 0 10px" }}
                    >
                      <i className="fas fa-search text-muted"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control border-left-0"
                    placeholder="Ketik nama cabang di sini..."
                    style={{
                      borderRadius: "0 10px 10px 0",
                      fontSize: "14px",
                      height: "45px",
                    }}
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)} // Mengupdate state pencarian
                  />
                </div>

                <div className="text-right">
                  <span
                    className="badge badge-light p-3"
                    style={{ color: "#458cf0", fontSize: "14px" }}
                  >
                    Menampilkan <strong>{filteredItems.length}</strong> dari{" "}
                    {dataAllGrafikCabang.length} Cabang
                  </span>
                </div>
              </div>

              {/* --- DATATABLE (MENGGUNAKAN filteredItems) --- */}
              <div
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  border: "1px solid #f1f5f9",
                }}
              >
                <DataTable
                  columns={colCabangPencairan}
                  data={filteredItems} // Pakai hasil filter di sini
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={10}
                  responsive
                  highlightOnHover
                  noDataComponent={
                    <div className="p-5 text-center text-muted">
                      <i
                        className="fas fa-folder-open fa-3x mb-3"
                        style={{ opacity: 0.2 }}
                      ></i>
                      <p>Data cabang tidak ditemukan...</p>
                    </div>
                  }
                />
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <div
          style={{
            minHeight: "100vh",
          }}
        >
          {/* SECTION 1: HEADER & PERIOD FILTER */}
          <Row className="mb-4">
            <Col xl="12">
              <Card
                style={{
                  border: "none",
                  borderRadius: "24px",
                  background:
                    "linear-gradient(135deg, #2885c7 0%, #334155 100%)",
                  color: "white",
                  boxShadow: "0 15px 35px rgba(40, 41, 59, 0.2)",
                  overflow: "visible", // Penting agar kalender tidak terpotong
                  minHeight: "350px", // Tinggi ditambah supaya lebih lega
                }}
              >
                <Card.Body className="p-0">
                  <Row
                    className="no-gutters align-items-stretch"
                    style={{ minHeight: "350px" }}
                  >
                    {/* --- SISI KIRI (Col 9): INFO UTAMA --- */}
                    <Col
                      md="9"
                      className="p-4 d-flex flex-column justify-content-center"
                    >
                      <Row className="align-items-center mb-4">
                        <Col sm="8" className="d-flex align-items-center">
                          {/* LOGO DIKEMBALIKAN KE UKURAN BESAR (200x150) */}
                          <div
                            style={{
                              backgroundColor: "#fff",
                              padding: "15px",
                              borderRadius: "20px",
                              marginRight: "25px",
                              boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
                              width: "200px",
                              height: "150px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <img
                              alt="Logo BPR Jatim"
                              src={
                                require("assets/img/bankaltimtara.png").default
                              }
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div>
                            <h5
                              className="m-0 text-info font-weight-bold"
                              style={{ fontSize: "16px", letterSpacing: "2px" }}
                            >
                              PERFORMANCE MONITOR
                            </h5>
                            <h2
                              className="m-0 font-weight-bold"
                              style={{ fontSize: "2.8rem", lineHeight: "1.1" }}
                            >
                              BPD KALTIMTARA
                            </h2>
                          </div>
                        </Col>

                        <Col sm="4" className="text-sm-right">
                          <p
                            className="mb-0 text-uppercase font-weight-bold"
                            style={{ fontSize: "1rem", color: "#e0e0e0" }}
                          >
                            Total Achievement
                          </p>
                          <h1
                            className="m-0 font-weight-bold"
                            style={{
                              color:
                                hasilPresentase > 100 ? "#00FF3F" : "#FF0000",
                              fontSize: "5rem", // Persentase dibuat sangat besar kembali
                              lineHeight: "1",
                            }}
                          >
                            {loadingPresentase ? (
                              <Skeleton width={120} />
                            ) : (
                              `${hasilPresentase}%`
                            )}
                          </h1>
                          {!loadingPresentase && (
                            <h5
                              className="font-weight-bold"
                              style={{
                                color:
                                  hasilPresentase > 100 ? "#00FF3F" : "#FF0000",
                              }}
                            >
                              {hasilPresentase > 100
                                ? "▲ Above Target"
                                : "▼ Below Target"}
                            </h5>
                          )}
                        </Col>
                      </Row>

                      {/* KPI STRIP PUTIH (UKURAN TEKS DIBESARKAN) */}
                      <div
                        className="bg-white text-dark p-4"
                        style={{
                          borderRadius: "18px",
                          boxShadow: "inset 0 2px 5px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Row className="text-center align-items-center no-gutters">
                          <Col md="3" className="border-right px-2">
                            <small
                              className="text-muted font-weight-bold d-block mb-2"
                              style={{ fontSize: "12px" }}
                            >
                              TOTAL REALISASI
                            </small>
                            <span
                              className="font-weight-bold"
                              style={{ fontSize: "18px" }}
                            >
                              {formatRupiah(totalNominalPencairan)}
                            </span>
                          </Col>
                          <Col md="3" className="border-right px-2">
                            <small
                              className="text-primary font-weight-bold d-block mb-2"
                              style={{ fontSize: "12px" }}
                            >
                              KONSUMTIF
                            </small>
                            <span
                              className="font-weight-bold text-primary"
                              style={{ fontSize: "18px" }}
                            >
                              {formatRupiah(totalNominalPencairanKonsumtif)}
                            </span>
                          </Col>
                          <Col md="3" className="border-right px-2">
                            <small
                              className="text-success font-weight-bold d-block mb-2"
                              style={{ fontSize: "12px" }}
                            >
                              PRODUKTIF
                            </small>
                            <span
                              className="font-weight-bold text-success"
                              style={{ fontSize: "18px" }}
                            >
                              {formatRupiah(totalNominalPencairanProduktif)}
                            </span>
                          </Col>
                          <Col md="3" className="px-2">
                            <small
                              className="text-warning font-weight-bold d-block mb-2"
                              style={{ fontSize: "12px" }}
                            >
                              TARGET NOMINAL
                            </small>
                            <span
                              className="font-weight-bold text-dark"
                              style={{ fontSize: "18px" }}
                            >
                              Rp {totalNominalTarget.toLocaleString("id-ID")}
                            </span>
                          </Col>
                        </Row>
                      </div>
                    </Col>

                    {/* --- SISI KANAN (Col 3): PERIODE DATA (UKURAN DI-UP) --- */}
                    <Col
                      md="3"
                      className="p-4 d-flex flex-column justify-content-center"
                      style={{
                        backgroundColor: "rgba(0,0,0,0.25)",
                        borderRadius: "0 24px 24px 0",
                        minHeight: "100%",
                      }}
                    >
                      <div className="mb-1">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5
                            className="font-weight-bold m-0 text-white"
                            style={{ fontSize: "18px" }}
                          >
                            <i className="fas fa-calendar-day mr-2 text-info"></i>{" "}
                            PERIODE DATA
                          </h5>
                        </div>

                        {/* TOMBOL EXCEL DIBUAT LEBIH MANTAP */}
                        {(auth.role === "admin" ||
                          auth.role === "super admin") && (
                          <Button
                            onClick={() => setModalExport(true)}
                            className="btn-block font-weight-bold mb-4 shadow-sm"
                            style={{
                              borderRadius: "12px",
                              backgroundColor: "#F5BF03",
                              border: "none",
                              color: "#1e293b",
                              padding: "10px",
                              fontSize: "14px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                            }}
                          >
                            <i
                              className="fas fa-file-excel"
                              style={{ fontSize: "18px" }}
                            ></i>
                            EXPORT EXCEL DATA
                          </Button>
                        )}
                      </div>

                      <div className="mb-3">
                        <label
                          className="font-weight-bold mb-2"
                          style={{ fontSize: "13px", color: "#cbd5e1" }}
                        >
                          DARI TANGGAL
                        </label>
                        <div className="rdt-static">
                          <ReactDatetime
                            inputProps={{
                              className:
                                "form-control border-0 bg-white text-dark text-center p-4",
                              style: {
                                borderRadius: "12px",
                                fontWeight: "900",
                                fontSize: "16px",
                                cursor: "pointer",
                              },
                              readOnly: true,
                            }}
                            onChange={(e) =>
                              setDariTgl(e.toDate().setHours(0, 0, 0, 0))
                            }
                            value={dariTgl}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </div>

                      <div>
                        <label
                          className="font-weight-bold mb-2"
                          style={{ fontSize: "13px", color: "#cbd5e1" }}
                        >
                          SAMPAI TANGGAL
                        </label>
                        <div className="rdt-static">
                          <ReactDatetime
                            inputProps={{
                              className:
                                "form-control border-0 bg-white text-dark text-center p-4",
                              style: {
                                borderRadius: "12px",
                                fontWeight: "900",
                                fontSize: "16px",
                                cursor: "pointer",
                              },
                              readOnly: true,
                            }}
                            onChange={(e) =>
                              setSmpTgl(e.toDate().setHours(23, 59, 0, 0))
                            }
                            value={smpTgl}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </div>
                      <style>{`
  /* CONTAINER UTAMA KALENDER */
  .rdtPicker {
    display: block !important;
    position: absolute !important;
    background-color: #ffffff !important; /* Putih bersih */
    border: 1px solid #e2e8f0 !important;
    border-radius: 16px !important;
    box-shadow: 0 20px 40px rgba(0,0,0,0.25) !important;
    margin-top: 10px !important;
    padding: 15px !important;
    width: 260px !important;
    z-index: 999999 !important;
    color: #1e293b !important; /* PASTI HITAM PEKAT */
  }

  /* WARNA TEKS HARI & ANGKA (AGAR TIDAK PUTIH) */
  .rdt th, .rdt td, .rdt span {
    color: #1e293b !important; /* Warna teks gelap agar kelihatan */
    font-size: 13px !important;
    padding: 5px !important;
    text-align: center !important;
  }

  /* WARNA HARI LIBUR / LUAR BULAN */
  .rdtOld, .rdtNew {
    color: #cbd5e1 !important; /* Abu-abu muda */
  }

  /* HEADER (BULAN & TAHUN) */
  .rdtSwitch {
    font-weight: 800 !important;
    color: #1e293b !important;
    cursor: pointer !important;
  }
  .rdtSwitch:hover { background: #f1f5f9 !important; }

  /* TOMBOL PANAH (PREV/NEXT) */
  .rdtPrev span, .rdtNext span {
    color: #1e293b !important;
    font-size: 18px !important;
    font-weight: bold !important;
  }

  /* SAAT HOVER HARI */
  .rdtDay:hover {
    background-color: #3b82f6 !important;
    color: white !important;
    border-radius: 8px !important;
    cursor: pointer !important;
  }

  /* HARI YANG DIPILIH (ACTIVE) */
  .rdtActive {
    background-color: #1e293b !important;
    color: white !important;
    border-radius: 8px !important;
  }

  /* HARI INI (TODAY) */
  .rdtToday:before {
    border-bottom: 7px solid #3b82f6 !important;
  }

  /* HACK AGAR TIDAK TERPOTONG CARD */
  .card {
    overflow: visible !important;
  }
`}</style>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* CSS HACK UNTUK KALENDER & DIVIDER */}
            </Col>
          </Row>

          {/* SECTION 2: SDM & STATUS STATS */}
          <Row className="mb-4 d-flex align-items-stretch">
            {/* SDM INFO (SIDE BAR) */}
            <Col xl="3" lg="4" md="12" className="mb-3 mb-lg-0">
              <Card
                style={{
                  border: "none",
                  borderRadius: "24px",
                  height: "550px", // Mengunci tinggi card agar seragam dan sejajar
                  boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                  overflow: "hidden",
                }}
              >
                <div className="p-3 border-bottom d-flex align-items-center justify-content-between">
                  <h6
                    className="m-1 font-weight-bold text-muted"
                    style={{ fontSize: "13px", letterSpacing: "1px" }}
                  >
                    INFORMASI SDM
                  </h6>
                  <img
                    src={require("assets/img/logobap.png").default}
                    style={{ height: "25px", opacity: 0.6 }}
                    alt="Vendor"
                  />
                </div>
                <Card.Body className="p-2 d-flex flex-column justify-content-around">
                  {[
                    {
                      label: "AREA MANAGER",
                      val: totalAM.totalAm,
                      color: "#4f46e5",
                      icon: "user-tie",
                    },
                    {
                      label: "SUPERVISOR",
                      val: totalSpv.totalSpv,
                      color: "#8b5cf6",
                      icon: "user-shield",
                    },
                    {
                      label: "MARKETING",
                      val: totalMarketing.totalSm,
                      color: "#0ea5e9",
                      icon: "users",
                    },
                    {
                      label: "CABANG",
                      val: totalCbg.totalCabang,
                      color: "#f59e0b",
                      icon: "building",
                    },
                  ].map((item, i) => (
                    <div
                      key={i}
                      className="d-flex align-items-center p-3 mx-1"
                      style={{
                        backgroundColor: "#f8fafc",
                        borderRadius: "15px",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        style={{
                          width: "42px",
                          height: "42px",
                          borderRadius: "12px",
                          backgroundColor: `${item.color}15`,
                          color: item.color,
                        }}
                        className="d-flex align-items-center justify-content-center mr-3"
                      >
                        <i className={`fas fa-${item.icon} fa-lg`}></i>
                      </div>
                      <div className="flex-grow-1">
                        <small
                          className="text-muted d-block font-weight-bold"
                          style={{ fontSize: "10px" }}
                        >
                          {item.label}
                        </small>
                        <h5
                          className="m-0 font-weight-bold text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          {item.val}{" "}
                          <small className="text-muted">Karyawan</small>
                        </h5>
                      </div>
                    </div>
                  ))}
                  {(auth.role === "admin" || auth.role === "super admin") && (
                    <div
                      className="p-3 mx-1"
                      style={{
                        backgroundColor: "#fdf2f2",
                        borderRadius: "15px",
                        border: "1px solid #fee2e2",
                      }}
                    >
                      <small
                        className="text-danger d-block font-weight-bold"
                        style={{ fontSize: "10px" }}
                      >
                        MARKETING SUDAH LOGIN
                      </small>
                      <h5
                        className="m-0 font-weight-bold text-danger"
                        style={{ fontSize: "18px" }}
                      >
                        {totalMarketing.totalLogin} Personil
                      </h5>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>

            {/* STATUS GRID (MAIN CONTENT AREA) */}
            <Col xl="9" lg="8" md="12">
              <Row
                className="no-gutters d-flex align-content-start" // Memastikan baris menumpuk ke atas sejajar SDM
                style={{
                  minHeight: "100%",
                  marginTop: "-8px", // Micro-adjustment agar sejajar presisi dengan Informasi SDM
                }}
              >
                {[
                  "Menunggu Konfirmasi",
                  "Diajukan",
                  "Revisi",
                  "Diproses",
                  "Disetujui",
                  "Ditolak",
                ].map((status, idx) => {
                  const colorMap = [
                    "#FFAF05",
                    "#1776F1",
                    "#fc556e",
                    "#e27637",
                    "#5AC967",
                    "#ff0000",
                  ];
                  const data = listAllTotalPengajuan?.find(
                    (item) => item[status],
                  )?.[status];
                  const statusLabel =
                    status === "Menunggu Konfirmasi" ? "Menunggu" : status;

                  return (
                    <Col
                      xl="4"
                      md="6"
                      sm="6"
                      key={idx}
                      className="p-2"
                      style={{
                        height: "auto",
                        marginBottom: "5px",
                      }}
                    >
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "24px",
                          height: "265px",
                          boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
                          overflow: "hidden",
                          margin: "0",
                          borderTop: `10px solid ${colorMap[idx]}`,
                          position: "relative",
                        }}
                      >
                        <Card.Body
                          className="p-3 d-flex flex-column justify-content-between text-center"
                          style={{
                            marginTop: "5px", // Micro-adjustment: Jarak konten ke border warna atas
                            paddingTop: "0", // Hilangkan padding top default
                          }}
                        >
                          <div className="pt-2">
                            <h6
                              className="text-muted font-weight-bold text-uppercase mb-0"
                              style={{
                                fontSize: "15px", // Tetap di-boost ke 15px
                                letterSpacing: "1.2px",
                              }}
                            >
                              {statusLabel}
                            </h6>
                            <hr
                              style={{ margin: "10px 0", opacity: "0.05" }}
                            ></hr>

                            <h1
                              className="font-weight-bold m-0"
                              style={{
                                color: colorMap[idx],
                                fontSize: "3.5rem", // Tetap besar dan jelas
                                lineHeight: "1.2", // Jarak antar teks mepet
                              }}
                            >
                              {data?.count || 0}
                            </h1>
                          </div>

                          <div
                            className="p-2"
                            style={{
                              backgroundColor: "#f8fafc",
                              borderRadius: "18px",
                              border: `2px solid ${colorMap[idx]}`, // Menggunakan border halus agar modern
                            }}
                          >
                            <Row className="text-center no-gutters align-items-center">
                              <Col className="border-right">
                                <small
                                  className="text-muted d-block font-weight-bold mb-1"
                                  style={{ fontSize: "11px" }}
                                >
                                  KONSUMTIF
                                </small>
                                <h5
                                  className="m-0 font-weight-bold text-dark"
                                  style={{ fontSize: "16px" }}
                                >
                                  {data?.konsumtif || 0}
                                </h5>
                              </Col>
                              <Col>
                                <small
                                  className="text-muted d-block font-weight-bold mb-1"
                                  style={{ fontSize: "11px" }}
                                >
                                  PRODUKTIF
                                </small>
                                <h5
                                  className="m-0 font-weight-bold text-dark"
                                  style={{ fontSize: "16px" }}
                                >
                                  {data?.produktif || 0}
                                </h5>
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </div>

        <div className="container-fluid">
          <style>{`
    .fade-in-chart { animation: fadeIn 0.8s ease-in-out; }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    .chart-card { border: none; border-radius: 24px; box-shadow: 0 20px 45px rgba(30, 41, 59, 0.05); transition: all 0.3s ease; }
    .chart-card:hover { transform: translateY(-5px); box-shadow: 0 25px 50px rgba(30, 41, 59, 0.1); }
  `}</style>

          <Row className="mt-4">
            <Col md="12">
              <Card className="chart-card">
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="d-flex align-items-center mb-1">
                        <div
                          className="mr-2"
                          style={{
                            width: "12px",
                            height: "24px",
                            backgroundColor: "#2885c7",
                            borderRadius: "4px",
                          }}
                        ></div>
                        <h4
                          className="m-0 font-weight-bold"
                          style={{ color: "#1e293b", letterSpacing: "-0.5px" }}
                        >
                          Analisis Performa Cabang
                        </h4>
                      </div>
                      <small className="text-muted font-weight-bold ml-3">
                        Monitoring Realisasi vs Target per Kantor Cabang
                      </small>
                    </div>
                    <Button
                      onClick={() => setModalDetail(!modalDetail)}
                      style={{
                        backgroundColor: "#f1f5f9",
                        color: "#2885c7",
                        border: "none",
                        fontWeight: "800",
                        borderRadius: "12px",
                        fontSize: "12px",
                      }}
                      className="px-4 py-2 shadow-none"
                    >
                      <i className="fas fa-expand-alt mr-2"></i> EXPLORE DETAIL
                    </Button>
                  </div>
                </Card.Header>

                <Card.Body className="px-4 pb-4">
                  {loadingChart ? (
                    <div className="p-2 text-center">
                      <Skeleton width="60%" height={30} className="mb-4" />
                      <Skeleton height={300} width="100%" borderRadius={20} />
                    </div>
                  ) : (
                    <div className="fade-in-chart">
                      {/* LEGEND MODERN */}
                      <div
                        className="d-flex flex-wrap justify-content-center mb-4 py-2"
                        style={{
                          backgroundColor: "#f8fafc",
                          borderRadius: "16px",
                          border: "1px solid #f1f5f9",
                        }}
                      >
                        {[
                          { label: "Target Cabang", color: "#6366f1" },
                          { label: "Total Realisasi", color: "#10b981" },
                          { label: "Konsumtif", color: "#3b82f6" },
                          { label: "Produktif", color: "#8b5cf6" },
                        ].map((item, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center mx-3 my-1"
                          >
                            <div
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: "4px",
                                backgroundColor: item.color,
                                marginRight: 8,
                                boxShadow: `0 4px 10px ${item.color}40`,
                              }}
                            ></div>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#475569",
                              }}
                            >
                              {item.label}
                            </span>
                          </div>
                        ))}
                      </div>

                      <VictoryChart
                        height={320}
                        width={900}
                        domainPadding={{ x: 40 }}
                        animate={{ duration: 1000, onLoad: { duration: 500 } }}
                      >
                        {/* GRID DAN AXIS YANG LEBIH CLEAN */}
                        <VictoryAxis
                          style={{
                            axis: { stroke: "#e2e8f0" },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Indeks Kantor Cabang"
                        />
                        <VictoryAxis
                          dependentAxis
                          style={{
                            axis: { stroke: "none" },
                            grid: {
                              stroke: "#f1f5f9",
                              strokeDasharray: "5, 5",
                            },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Nominal Pencairan (Miliar)"
                        />

                        <VictoryGroup offset={14}>
                          {[1, 0, 2, 3].map((seriesIdx, i) => {
                            const modernColors = [
                              "#6366f1",
                              "#10b981",
                              "#3b82f6",
                              "#8b5cf6",
                            ];
                            return (
                              <VictoryBar
                                key={i}
                                data={chartData.series[seriesIdx].map(
                                  (val, idx) => ({
                                    x: chartData.labels[idx],
                                    y: val / 1000000000,
                                    label: `${(val / 1000000000).toFixed(1)}M`,
                                  }),
                                )}
                                barWidth={10}
                                style={{
                                  data: {
                                    fill: modernColors[i],
                                    fillOpacity: 0.9,
                                  },
                                }}
                                cornerRadius={{ top: 6 }}
                                labelComponent={
                                  <VictoryTooltip
                                    flyoutStyle={{
                                      fill: "#1e293b",
                                      strokeWidth: 0,
                                      borderRadius: 8,
                                    }}
                                    style={{
                                      fill: "white",
                                      fontSize: 10,
                                      fontWeight: "bold",
                                    }}
                                    pointerLength={6}
                                  />
                                }
                              />
                            );
                          })}
                        </VictoryGroup>
                      </VictoryChart>

                      {/* INDEKS CABANG DENGAN STYLE KOTAK MODERN */}
                      <div
                        className="mt-4 p-3"
                        style={{
                          background:
                            "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                          borderRadius: "24px",
                          border: "1px solid #f1f5f9",
                        }}
                      >
                        <Row>
                          {dataGrafikCabang.map((cabang, index) => (
                            <Col
                              lg="3"
                              md="4"
                              sm="6"
                              key={index}
                              className="mb-2"
                            >
                              <div
                                className="d-flex align-items-center p-2 bg-white"
                                style={{
                                  borderRadius: "14px",
                                  border: "1px solid #f1f5f9",
                                  transition: "0.2s",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center justify-content-center mr-3 font-weight-bold"
                                  style={{
                                    minWidth: "30px",
                                    height: "30px",
                                    background:
                                      "linear-gradient(135deg, #2885c7 0%, #1e293b 100%)",
                                    color: "white",
                                    borderRadius: "10px",
                                    fontSize: "12px",
                                    boxShadow:
                                      "0 4px 12px rgba(40, 133, 199, 0.3)",
                                  }}
                                >
                                  {String.fromCharCode(65 + index)}
                                </div>
                                <span
                                  className="text-dark font-weight-bold text-truncate"
                                  style={{
                                    fontSize: "11px",
                                    letterSpacing: "0.3px",
                                  }}
                                >
                                  {cabang.nama}
                                </span>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* GRAFIK 2: PERFORMA INDIVIDU */}
          <Row className="mt-4 pb-5">
            <Col md="12">
              <Card
                className="chart-card"
                style={{
                  background:
                    "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                }}
              >
                <Card.Header className="bg-transparent border-0 pt-4 px-4 d-flex justify-content-between align-items-center flex-wrap">
                  <div className="d-flex align-items-center">
                    <div
                      className="p-3 bg-warning mr-3"
                      style={{
                        borderRadius: "16px",
                        boxShadow: "0 8px 20px rgba(251, 191, 36, 0.3)",
                      }}
                    >
                      <i className="fas fa-user-tie text-white"></i>
                    </div>
                    <div>
                      <h4
                        className="m-0 font-weight-bold text-dark"
                        style={{ letterSpacing: "-0.5px" }}
                      >
                        Performa Individu: {auth.nama}
                      </h4>
                      <small className="text-muted font-weight-bold">
                        Tinjauan Pencairan Bulanan Tahun {tahun}
                      </small>
                    </div>
                  </div>
                  <div style={{ width: "160px" }}>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      defaultValue={{ label: yearNow, value: yearNow }}
                      onChange={(value) => setTahun(value.value)}
                      options={listYear}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "14px",
                          border: "2px solid #f1f5f9",
                          boxShadow: "none",
                          fontWeight: "bold",
                        }),
                      }}
                    />
                  </div>
                </Card.Header>

                <Card.Body className="px-4">
                  {loadingChart ? (
                    <div className="p-5 text-center">
                      <Spinner color="warning" />
                    </div>
                  ) : (
                    <div className="fade-in-chart">
                      <div className="d-flex flex-wrap justify-content-center mb-4 py-2">
                        {[
                          { label: "Target User", color: "#fbbf24" },
                          { label: "Total Realisasi", color: "#34d399" },
                          { label: "Konsumtif", color: "#3b82f6" },
                          { label: "Produktif", color: "#8b5cf6" },
                        ].map((item, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center mx-3"
                          >
                            <div
                              style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: item.color,
                                marginRight: 6,
                                border: "2px solid white",
                                boxShadow: "0 0 0 1px #e2e8f0",
                              }}
                            ></div>
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: "800",
                                color: "#64748b",
                                textTransform: "uppercase",
                              }}
                            >
                              {item.label}
                            </span>
                          </div>
                        ))}
                      </div>

                      <VictoryChart
                        height={300}
                        width={900}
                        domainPadding={{ x: 45 }}
                      >
                        <VictoryAxis
                          style={{
                            axis: { stroke: "#e2e8f0" },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Bulan"
                        />
                        <VictoryAxis
                          dependentAxis
                          style={{
                            axis: { stroke: "none" },
                            grid: {
                              stroke: "#f1f5f9",
                              strokeDasharray: "5, 5",
                            },
                            tickLabels: {
                              fontSize: 10,
                              fontWeight: "600",
                              fill: "#64748b",
                              padding: 10,
                            },
                            axisLabel: {
                              padding: 35,
                              fontWeight: "700",
                              fontSize: 12,
                              fill: "#1e293b",
                            },
                          }}
                          label="Nominal Pencairan (Miliar)"
                        />
                        <VictoryGroup offset={15}>
                          {[0, 1, 2, 3].map((seriesIdx, i) => {
                            const userColors = [
                              "#fbbf24",
                              "#34d399",
                              "#3b82f6",
                              "#8b5cf6",
                            ];
                            return (
                              <VictoryBar
                                key={i}
                                data={chartDataUser.series[seriesIdx].map(
                                  (val, idx) => ({
                                    x: chartDataUser.labels[idx],
                                    y: val / 1000000000,
                                    label: `${(val / 1000000000).toFixed(1)}M`,
                                  }),
                                )}
                                barWidth={10}
                                cornerRadius={{ top: 5 }}
                                style={{ data: { fill: userColors[i] } }}
                                labelComponent={
                                  <VictoryTooltip
                                    flyoutStyle={{
                                      fill: "#1e293b",
                                      strokeWidth: 0,
                                    }}
                                    style={{
                                      fill: "white",
                                      fontSize: 10,
                                      fontWeight: "bold",
                                    }}
                                  />
                                }
                              />
                            );
                          })}
                        </VictoryGroup>
                      </VictoryChart>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
    // </SkeletonTheme>
  );
}

export default DashboardUtama;
